import { GridRenderCellParams } from "@mui/x-data-grid";
import { AssignRobotToOrganization } from "components/organisms/panels/AssignRobotToOrganization";
import { useState } from "react";
import { PushButton } from "../../atoms/buttons/PushButton";

interface Props {
  refetch: () => void;
}

export const AssignRobotCell = ({
  refetch,
  ...params
}: GridRenderCellParams & Props) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <PushButton
        onClick={(e: any) => {
          setDrawerOpen(true);
          e.stopPropagation();
        }}
        variant="outlined"
      >
        Assign
      </PushButton>
      <AssignRobotToOrganization
        robot={params.row}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        refetch={refetch}
      />
    </>
  );
};
